import en from './en.json';
import ru from './ru.json';
import { i18n } from 'locales';

i18n.addResourceBundle('en', 'exchange', en, true);
i18n.addResourceBundle('ru', 'exchange', ru, true);
